module.exports = __webpack_public_path__ + "static/chicken-siomai-9c9a39dcad1de4b89a69cd366219ef63.jpg";